import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { DrawerModule } from 'primeng/drawer';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    DrawerModule,
    SidebarComponent,
    FormsModule,
    RouterOutlet,
    ToggleSwitchModule,
  ],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css'],
})
export class MainLayoutComponent implements OnInit {
  sidebarVisible = false;
  visible = false;
  mode: 'overlay' | 'push' = 'overlay';

  ngOnInit(): void {
    // Initialize component
    this.setSidebarVisibility();
  }

  setSidebarVisibility() {
    this.visible = window.innerWidth > 1280;
    this.mode = window.innerWidth > 1280 ? 'push' : 'overlay';
  }

  toggleSidebar() {
    this.visible = !this.visible;
  }
}
